import { IntegrationSoftware } from '../../components/statTracker2/settings/integrations/Integrations';
import { getRequest } from '../../helpers/httpHandler2';

const getAllIntegrations = async (
  teamId: number
): Promise<IntegrationSoftware[]> => {
  const integrations: IntegrationSoftware[] = await getRequest(
    '/api/teamIntegrations/providers',
    { teamId }
  );
  return integrations;
};

export { getAllIntegrations };
